import React from "react";
import {
  Grid,
  TextField,
  Switch,
  FormControlLabel,
  FormLabel,
  RadioGroup,
  Radio,
  FormControl,
} from "@material-ui/core";

const JobDetailsViewStep1 = ({
  selectedCompany,
  discreteCompany,
  employmentType,
  jobTitle,
  jobDescription,
  jobReqs,
}) => {
  return (
    <Grid container>
      <Grid item xs={4}>
        <TextField
          margin="normal"
          value={selectedCompany}
          label="Company Name"
        />
      </Grid>
      <Grid
        item
        xs={4}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <FormControlLabel
          label="Confidential Company"
          control={
            <Switch
              checked={discreteCompany}
              color="primary"
              name="DiscreteCompany"
            />
          }
        />
      </Grid>
      <Grid item xs={4}>
        <FormControl component="fieldset" disabled>
          <FormLabel>Employement Type</FormLabel>
          <RadioGroup
            aria-label="employmentType"
            name="employmentType"
            value={employmentType}
            row
          >
            <FormControlLabel
              value="recruitment"
              control={<Radio color="primary" />}
              label="Recruitement"
            />
            <FormControlLabel
              value="employment"
              control={<Radio color="primary" />}
              label="Employment"
            />
          </RadioGroup>
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        <TextField
          required
          label="Job Title"
          id="jobTitle"
          margin="normal"
          fullWidth
          value={jobTitle}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          id="job-description"
          label="Job Description"
          InputLabelProps={{
            shrink: jobDescription !== "",
          }}
          multiline
          fullWidth
          rows={5}
          defaultValue={jobDescription}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          id="job-requirements"
          label="Job Requirements"
          multiline
          fullWidth
          rows={5}
          InputLabelProps={{
            shrink: jobReqs !== "",
          }}
          defaultValue={jobReqs}
        />
      </Grid>
    </Grid>
  );
};
export default JobDetailsViewStep1;
